import { Column } from 'react-table';
import { DateValue } from '@visx/mock-data/lib/generators/genDateValue';
import { ChartLineData, ChartLineKeys } from '../components/Chart';
import { ReportDatum } from '../pages/ApplicationReport';

export function lineDataToCSVValueArray(chartLineData: ChartLineData) {
  const valuesByDate = Object.keys(chartLineData)
    .map((lineKey) => [lineKey, chartLineData[lineKey as ChartLineKeys]?.data])
    .reduce((acc, [lineKey, lineData]) => {
      (lineData as DateValue[]).forEach(({ date, value }) => {
        const dateString = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
        if (!acc[dateString]) acc[dateString] = { date };
        acc[dateString][lineKey as string] = value;
      });
      return acc;
    }, {} as { [key: string]: any });

  return Object.keys(valuesByDate)
    .sort((a, b) => (valuesByDate[a].date > valuesByDate[b].date ? 1 : -1))
    .reduce((acc, date, index) => {
      acc[index] = { ...valuesByDate[date], date };
      return acc;
    }, [] as Array<any>);
}

export function translationTableDataToCSV(columns: Column<ReportDatum>[], data: ReportDatum[]) {
  const header = columns.map((column) => (column?.Header || '').toString().toLowerCase());
  const rows = data.map((datum) =>
    columns.map((column) => datum[column.accessor as keyof ReportDatum]),
  );

  // escapes strings with commas and formats into a csv format
  return [
    header.join(','),
    ...rows.map((row) =>
      row
        .map((cell) => (typeof cell === 'string' && cell.includes(',') ? `"${cell}"` : cell))
        .join(','),
    ),
  ].join('\n');
}

export function objectsToCSV<T>(headers: Array<keyof T>, objects: T[]): string {
  if (!objects.length) return '';

  return [headers, ...objects.map((object) => headers.map((header) => object[header]))]
    .map((line) => line.join(','))
    .join('\n');
}

export function downloadCSV(filename: string, filecontent: string) {
  const csvFile = new Blob([filecontent], { type: 'text/csv' });
  const downloadLink = document.createElement('a');
  downloadLink.download = filename;
  downloadLink.href = window.URL.createObjectURL(csvFile);
  downloadLink.style.display = 'none';
  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
}
